import { updateIntentDiscount } from "../../services/api";

export const sdkUpdateIntentDiscount = async ({
  intentId,
  discount,
  lang,
}: {
  intentId: string;
  discount: Discount;
  lang: string;
}) => {
  try {
    const response = await updateIntentDiscount({
      discount,
      lang,
      intentId,
    });

    return response.data;
  } catch (error) {
    const errorsList = (await error?.json)?.status?.errors || [];
    return Promise.reject(
      errorsList.reduce((acc, curr) => ({ ...acc, ...curr }), {})
    );
  }
};
